<app-fixed-content-page [content]="content" />

<ng-template #content>
  <div class="m-t-5 m-b-3 content-layout-column">
    <div class="completed-assessment-logo">
      <svg-icon
        role="img"
        src="assets/images/completed-assessment.svg"
        data-ua-id="completed-assessment-logo"
      >
      </svg-icon>
    </div>
  </div>

  <h2 class="text-bold m-b-3 content-layout-column">
    <app-content
      [key]="pageHeadingKey"
      [value]="pageHeadingValue$ | async"
      [trackingId]="pageHeadingKey"
    >
      <span defaultContent> You have completed the cognitive assessment. </span>
    </app-content>
  </h2>

  <div class="content-layout-column">
    <app-content
      [key]="pageBodyKey"
      [value]="pageBodyValue$ | async"
      [trackingId]="pageBodyKey"
    >
      <p defaultContent>You can now close this browser window.</p>
    </app-content>
  </div>
</ng-template>
